import { render, staticRenderFns } from "./minbestand.vue?vue&type=template&id=30f1f498&scoped=true&"
import script from "./minbestand.vue?vue&type=script&lang=js&"
export * from "./minbestand.vue?vue&type=script&lang=js&"
import style0 from "./minbestand.vue?vue&type=style&index=0&id=30f1f498&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f1f498",
  null
  
)

export default component.exports